export const tenantNavBar = [
  {
    text: "Tenant",
    icon: "mdi-book-open-page-variant",
    items: []

  },
];

